

import { useDispatch, useSelector } from 'react-redux'
import PageTopTitle from '../../components/shared/PageTopTitle'
import styled from 'styled-components'
import Btn from '../../components/shared/button/Btn'

import { showModal } from '../../features/modal/modalSlice'
import InputText from '../../components/shared/input/new/InputText'
import { useState } from 'react'
import ProfilimAraclarContainer from '../../components/profilimContainer/ProfilimAracItemContainer'
import { useEffect } from 'react'
import { getProfilOzVarlikArac } from '../../features/companyProfile/companyProfileSlice'
import useWindowDimensions from '../../hooks/useWindowSize'
import ProfilimAracItemContainer from '../../components/profilimContainer/ProfilimAracItemContainer'
import ProfilimAracItemContainerMobile from '../../components/profilimContainer/ProfilimAraclarContainerMobile'

const Container = styled.div`
  width: 100%;
  cursor: pointer;

  .wrapper{
    display: flex;
    flex-direction: column;
    width: 100%;

    .content{
      gap: 60px;
      margin: 0 30px;
      margin-top: 20px;

      .btn-group{
        width: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 20px;
      }

      .filter-container{
        width: 100%;
        height: auto;
        /* border: 1px solid;
        border-color: ${({theme}) => theme.mainBorderColor}; */
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 20px 0;

        .filter-input-grp{
          margin: 0 2px;
          display: flex;
          gap: 20px;
        }

      }

      .titles{
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
        gap: 15px;
        font-weight: var(--font-weight-lg);
        font-size: var(--font-size-sm);
        padding: 10px 15px;
        text-align: center;
      }
    }
  }
`

const Araclarim = () => {

    const dispatch = useDispatch()
    const {ozVarlikAracList} = useSelector((state) => state.companyProfile)

    const [plaka, setPlaka]= useState("")
    const {windowDimensions} = useWindowDimensions()

    const titles = ["Plaka", "Araç Tipi", "Kasa Tipi", "Kasko Geçerlilik Tarihi", "Muayene Geçerlilik Tarihi", "Trafik Sigorta Geçerlilik Tarihi", ""]

    useEffect(() => {
      dispatch(getProfilOzVarlikArac(plaka))
    }, [plaka])
    
  return (
    <Container>
    <div className="wrapper">
      <PageTopTitle title={"Özvarlık Araçlarım"} position='sticky'/>
      <div className="content">
   
        <div className="filter-container">
          <div className="filter-input-grp">
            <InputText data={plaka} setData={(e) => setPlaka(e.target.value)} inputWidth={windowDimensions.width > 750 ? '220px' : "120px"} labelText={"Plaka"}/>
            <Btn bgColor={"transparent"} color={"#E85446"} padding='0 10px' width={windowDimensions.width > 750 ? '160px' : "80px"}>Temizle</Btn>
          </div>
          <Btn bgColor={"transparent"} color={"#E85446"} handleClick={()=> dispatch(showModal("addProfilimAraclarim"))} padding='0 10px' width={windowDimensions.width > 750 ? '160px' : "100px"}>Araç Ekle</Btn>
        </div>

        {
          windowDimensions.width > 850 &&
          <div className="titles">
            {titles.map((item) => {
              return(
                <p>{item}</p>
              )
            })}
          </div>
        }

        {
          windowDimensions.width > 850 &&
            ozVarlikAracList?.map((item) => (
            <ProfilimAracItemContainer data={item} />
          )) 
        }

        {
          windowDimensions.width <= 850 &&
            ozVarlikAracList?.map((item) => (
            <ProfilimAracItemContainerMobile data={item} />
          )) 
        }

      </div>
    </div>
  </Container>

  )
}

export default Araclarim